// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"691":"3c23efd81c2652715aba","724":"872a27971bbe694f4ba4","744":"2bc11f9f219c0ea9877f"}[chunkId] + ".chunk.js";
};